export const isDevelopmentOrMockMode = (): boolean => {
  return import.meta.env.MODE === "development" || import.meta.env.VITE_IS_SHELL_DATA_MOCKED.trim() === "true";
};

export const focusOnFirstError = () => {
  window.requestAnimationFrame(() => {
    const firstErrorInput = document.querySelector<HTMLInputElement | HTMLSelectElement>(".is-invalid input, .is-invalid select");
    if (firstErrorInput) {
      firstErrorInput.focus();
    }
  });
};

// This is temporary workaround while there are no ref capabilities from green component library for textinput.
export const focusOnInput = (id: string) => {
  window.requestAnimationFrame(() => {
    const input = document.getElementById(id);
    if (input) {
      input.focus();
    }
  });
};

export const scrollToElement = (element: HTMLElement) => {
  if (!element) {
    return;
  }

  const header = document.querySelector<HTMLElement>("body > header");
  const headerHeight = header?.clientHeight ?? 0;
  const elementPosition = element.getBoundingClientRect().top;
  const offsetPosition = elementPosition + window.scrollY - headerHeight;

  window.scroll({
    top: offsetPosition,
    behavior: "smooth",
  });
};

export function isNumber(input: any): input is number {
  return typeof input === "number" && !isNaN(input);
}

export function memoizeAsync<T extends (...args: any[]) => Promise<any>>(fn: T): T {
  const cache = new Map<string, Promise<ReturnType<T>>>();

  return function (...args: any[]): Promise<ReturnType<T>> {
    const key = JSON.stringify(args);
    if (cache.has(key)) {
      return cache.get(key) as Promise<ReturnType<T>>;
    }
    const result = fn.apply(this, args).catch((error) => {
      cache.delete(key);
      throw error;
    });
    cache.set(key, result);
    return result;
  } as T;
}

export function getSliderStepValue(number: number | undefined): number {
  const DIGIT_THRESHOLD = 4;

  const digitsCount = number?.toString().length;
  if (!digitsCount) {
    return 1;
  }

  const step = Math.pow(10, digitsCount - DIGIT_THRESHOLD);
  if (step < 1) {
    return 1;
  }

  return step;
}

export function getMaxNumberInputLength(number: number | undefined): number | undefined {
  const THOUSANDS_GROUP_SIZE = 3;

  const digitsCount = number?.toString().length;
  if (!digitsCount) {
    return undefined;
  }

  const thousandsSeparatorCount = Math.floor((digitsCount - 1) / THOUSANDS_GROUP_SIZE);

  return digitsCount + thousandsSeparatorCount + 1;
}
